/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_TitleInputs */

const en_admin_create_title = /** @type {(inputs: Admin_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create New Admin Account`)
};

const de_admin_create_title = /** @type {(inputs: Admin_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Admin-Account erstellen`)
};

/**
* | output |
* | --- |
* | "Create New Admin Account" |
*
* @param {Admin_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_title = /** @type {((inputs?: Admin_Create_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_title(inputs)
	return en_admin_create_title(inputs)
});